import { render, staticRenderFns } from "./ExchangeInfo.vue?vue&type=template&id=e966d288&"
import script from "./ExchangeInfo.vue?vue&type=script&lang=js&"
export * from "./ExchangeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports